import React, {useState, useLayoutEffect} from "react";
import QuestionEditChoice from "../QuestionEditChoice";
import {
    isSurveyEditRestrictedSelector,
    updateQuestionInSurveyAtIdx,
    validateQuestionAtIndex
} from "../../../../../../slices/surveyEditorSlice";
import {connect, useDispatch, useSelector} from "react-redux";
import {Draggable, Droppable} from "react-beautiful-dnd";
import {validateChoices} from "../../../../../../utils/SurveyValidationUtils"

function CommonDefaultQuestionEdit(props) {

    const dispatch = useDispatch();

    const surveyEditRestricted = useSelector(isSurveyEditRestrictedSelector);
    const [choicesValidationResult, setChoicesValidationResult] = useState(validateChoices(props.questionData.choices));

    useLayoutEffect(() => {
        setChoicesValidationResult(validateChoices(props.questionData.choices));
    }, [props.questionData.choices]);

    const handleQuestionChoiceTextChange = (event, choiceIdx) => {
        const newText = event.target.value;
        if (newText || newText === "") {
            const {questionData, idx} = props;
            let newQuestionData = JSON.parse(JSON.stringify(questionData));
            newQuestionData.choices[choiceIdx].label = newText;
            props.validateQuestionAtIndex(idx, newQuestionData);
        }
    };

    const handleAddNewChoice = (event) => {
        const {questionData, idx} = props;
        let newQuestionData = JSON.parse(JSON.stringify(questionData));
        let newChoice = {
            "label": "",
            "value": (newQuestionData.choices.length + 1).toString()
        };

        newQuestionData.choices.push(newChoice);
        dispatch(updateQuestionInSurveyAtIdx({idx: idx, questionData: newQuestionData}));
    };

    const handleRemoveChoice = (event, choiceIdx) => {
        const {questionData, idx} = props;
        let newQuestionData = JSON.parse(JSON.stringify(questionData));

        newQuestionData.choices.splice(choiceIdx, 1);
        for (let index = 0; index < newQuestionData.choices.length; index++) {
            newQuestionData.choices[index].value = (index + 1).toString();
        }
        props.validateQuestionAtIndex(idx, newQuestionData);
    };

    const buildChoicesList = () => {
        const {questionData, questionValid} = props;
        let htmlChoicesList;

        if(!surveyEditRestricted) {
            htmlChoicesList = questionData.choices.map((choice, index) => {
                const idChoice = "choiceId_" + questionData.id + "_" + choice.value + "_" + index;
                return (
                    <Draggable class="draggable" draggableId={index + "_draggables_choice"} index={index}
                               key={"draggable_choice_item_key_" + index}>
                        {(provided) => (
                            <div ref={provided.innerRef}
                                 {...provided.draggableProps}
                                 {...provided.dragHandleProps} key={choice.value}>

                                <QuestionEditChoice
                                    idChoice={idChoice}
                                    key={idChoice}
                                    choiceText={choice.label}
                                    choiceValue={choice.value}
                                    onChange={(event) => {
                                        handleQuestionChoiceTextChange(event, index)
                                    }}
                                    handleRemoveChoice={(event) => {
                                        handleRemoveChoice(event, index)
                                    }}
                                    questionValid={questionValid}
                                    errorMessage={choicesValidationResult[index]}
                                    showRemoveButton={questionData.choices.length > 2}
                                    maxLength={512}
                                />
                            </div>
                        )}
                    </Draggable>

                );
            });
        } else {
            htmlChoicesList = questionData.choices.map((choice, index) => {
                const idChoice = "choiceId_" + questionData.id + "_" + choice.value + "_" + index;
                return (<QuestionEditChoice
                    idChoice={idChoice}
                    key={idChoice}
                    choiceText={choice.label}
                    choiceValue={choice.value}
                    onChange={(event) => {
                        handleQuestionChoiceTextChange(event, index)
                    }}
                    handleRemoveChoice={(event) => {
                        handleRemoveChoice(event, index)
                    }}
                    questionValid={questionValid}
                    errorMessage={choicesValidationResult[index]}
                    showRemoveButton={questionData.choices.length > 2}
                    maxLength={512}
                />);
            });
        }

        return htmlChoicesList;
    };

    const htmlChoicesList = buildChoicesList();
    return (
        <React.Fragment>
            <div className="questionaire__builder__question__subtitle questionaire__builder__col1">
                <span>ANSWERS</span>
                {/*<a className="questionaire__builder__question__subtitle__action questionaire__builder__question__subtitle__action--addbulk"*/}
                   {/*href="#" onClick={(event) => {event.preventDefault();}}>Add answers in bulk</a>*/}
            </div>
            <div className="questionaire__builder__question__inputs">
                <div className="questionaire__builder__col1">
                    <Droppable droppableId="droppable_choice" class="droppable_choice" type={props.questionData.id}>
                        {(provided) => (
                            <div
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                            >
                                {htmlChoicesList}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>

                </div>
            </div>
            <div className="questionaire__builder__question__subtitle questionaire__builder__col1">
                <a className="questionaire__builder__question__subtitle__action"
                   href="#" onClick={(event) => {event.preventDefault();handleAddNewChoice();}}>+ Add new answer</a>
            </div>
        </React.Fragment>
    );
}

function mapStateToProps(state) {
    return {};
}

const mapDispatchToProps = {validateQuestionAtIndex};

export default connect(mapStateToProps, mapDispatchToProps)(CommonDefaultQuestionEdit);